import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";

import { getAllDivisions } from "../../Divisions/redux/DivisionActions";
import { closeModal } from "../../../common/GlobalModal/redux/GlobalModalActions";
import { CustomInputText } from "../../../common/CustomInputs/CustomInputs";
import CustomSelect from "../../../common/CustomReactSelectComponent";
import ReactDatePicker from "../../../common/CustomReactDateTimePicker/CustomReactDateTimePicker";

const EnterFilterInfo = ({
  getAllDivisions,
  filterSwitchValues,
  divisions,
  closeModal,
}) => {
  const [values, setValues] = useState({
    name: "",
    company: "",
    submittedOnFrom: "",
    submittedOnTo: "",
    division: null,
    marketingCampaign: "",
  });
  const [divisionOptions, setDivisionOptions] = useState([]);

  useEffect(() => {
    getAllDivisions();
  }, []);

  useEffect(() => {
    if (divisions.data) optionsForSelect();
  }, [divisions]);

  const optionsForSelect = () => {
    const options = [];
    divisions.data.forEach((division) => {
      options.push({
        label: division.name,
        value: division.id,
      });
    });
    setDivisionOptions(options);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const onDivisionChange = (value) => {
    setValues({ ...values, division: value ? value.value : null });
  };

  const onCancelClick = () => {
    closeModal("enter_filter_info");
  };

  const onSearchClick = () => {
    //api call here

    closeModal("enter_filter_info");
  };

  return (
    <Fragment>
      <Row>
        <Col>
          <Card>
            <CardHeader>Advanced Search</CardHeader>
            <CardBody>
              {filterSwitchValues.name && (
                <Row className="mb-2">
                  <Col md="6">
                    <CustomInputText
                      value={values.name}
                      label="Name"
                      name="name"
                      onChange={onChange}
                      placeholder="Name"
                    />
                  </Col>
                </Row>
              )}
              {filterSwitchValues.company && (
                <Row className="mb-2">
                  <Col md="6">
                    <CustomInputText
                      value={values.company}
                      label="Company"
                      name="company"
                      onChange={onChange}
                      placeholder="Company"
                    />
                  </Col>
                </Row>
              )}
              {filterSwitchValues.marketingCampaign && (
                <Row className="mb-2">
                  <Col md="6">
                    <CustomInputText
                      value={values.marketingCampaign}
                      label="Marketing Campaign"
                      name="marketingCampaign"
                      onChange={onChange}
                      placeholder="Marketing Campaign"
                    />
                  </Col>
                </Row>
              )}
              {filterSwitchValues.division && (
                <Row className="mb-2">
                  <Col md="6">
                    <CustomSelect
                      defaultValue={values.division}
                      label="Division"
                      options={divisionOptions}
                      onChange={onDivisionChange}
                      isMulti={false}
                      isClearable={true}
                      placeholder="Division"
                    />
                  </Col>
                </Row>
              )}
              {filterSwitchValues.submittedOn && (
                <Row>
                  <Col md="6">
                    <ReactDatePicker
                      label="Submitted On (minimum)"
                      placeholder="mm/dd/yyyy"
                      name="submittedOnFrom"
                      disabled={false}
                      onChange={onChange}
                      value={values.submittedOnFrom}
                    />
                  </Col>
                  <Col md="6">
                    <ReactDatePicker
                      label="Submitted On (maximum)"
                      placeholder="mm/dd/yyyy"
                      name="submittedOnTo"
                      disabled={false}
                      onChange={onChange}
                      value={values.submittedOnTo}
                    />
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            onClick={onCancelClick}
            size="sm"
            color="danger"
            className="float-right ml-2"
          >
            Cancel
          </Button>
          <Button
            onClick={onSearchClick}
            size="sm"
            className="gold-color-button float-right"
          >
            Search
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
};

EnterFilterInfo.propTypes = {
  filterSwitchValues: PropTypes.object.isRequired,
  getAllDivisions: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  divisions: state.divisions.divisions,
});

export default connect(mapStateToProps, { getAllDivisions, closeModal })(
  EnterFilterInfo
);
